enum ThirdPartySyncDisplayState {
    None = 0,
    Grayedout = 1,
    Green = 2,
    Yellow = 3,
    Red = 4
}

export { ThirdPartySyncDisplayState };
